"use client";

import { motion, type Variants } from "framer-motion";
import { Container } from "@/components/ui/Container";
import { Button } from "@/components/ui/Button";
import { HeroVideoBackground } from "@/components/sections/HeroVideoBackground";
import { OpenSignupButton } from "@/components/popups/OpenSignupButton";
import { usePrefersReducedMotion } from "@/lib/motion";

const container: Variants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.1 } },
};

const item: Variants = {
  hidden: { opacity: 0, y: 22 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } },
};

export function Hero() {
  const reduced = usePrefersReducedMotion();

  return (
    <section
      data-nano-scene="hero"
      // -mt-18 cancela o pt-18 que o <main> ganhou pra compensar o header
      // (agora fixed) — só o Hero precisa ficar atrás do header no topo.
      className="relative -mt-18 flex min-h-[640px] items-center overflow-hidden py-28 sm:min-h-[760px] sm:py-36"
    >
      <HeroVideoBackground />

      <Container className="relative flex flex-col items-center text-center">
        <motion.div
          initial={reduced ? undefined : "hidden"}
          animate={reduced ? undefined : "show"}
          variants={container}
          className="flex flex-col items-center"
        >
          <motion.div variants={item} className="flex min-h-[330px] w-full flex-col items-center justify-center">
            <h1 className="max-w-5xl text-4xl font-black uppercase italic leading-[0.95] tracking-tight text-text-secondary sm:text-6xl lg:text-7xl">
              Sua operação de conteúdo mais estável, integrada e{" "}
              <span
                className="text-accent-lime"
                style={{ textShadow: "0 0 24px rgba(153,255,0,0.35)" }}
              >
                pronta para crescer.
              </span>
            </h1>

            <p className="mt-8 max-w-3xl text-lg text-text-secondary sm:text-xl">
              A SAT Labs integra cloud, streaming, IPTV, OTT, VOD e monitoramento para
              provedores reduzirem falhas, ganharem controle e escalarem com segurança.
            </p>
          </motion.div>

          <motion.div variants={item} className="mt-8 flex flex-wrap items-center justify-center gap-4">
            <OpenSignupButton size="lg">Solicitar diagnóstico</OpenSignupButton>
            <Button href="#solucoes" variant="secondary" size="lg">
              Conhecer soluções
            </Button>
          </motion.div>

          <motion.p
            variants={item}
            className="mt-10 font-mono text-xs font-semibold uppercase tracking-[0.12em] text-text-primary/80"
          >
            Menos falhas. Mais controle. Estrutura pronta para crescer.
          </motion.p>
        </motion.div>
      </Container>
    </section>
  );
}
